export default "__VITE_ASSET__24m36CCw__"